import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchSubPartnerDetail } from '@/features/sub-partners/api'
import { subPartnerParamsSchema } from '@/routes/_protected/$tenantKey/settings/sub-partners/$subPartnerId/-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/sub-partners/$subPartnerId'
)({
  parseParams: (params) => parse(subPartnerParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, subPartnerId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      partner: await fetchSubPartnerDetail(
        {
          tenantKey,
          subPartnerId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.partner.name
    }
  ]
})
